module.exports = __webpack_public_path__ + "img/emailEle.3c7e7c33.svg";